/* global axios */
import ApiClient from './ApiClient';

class PostSaleCasesAPI extends ApiClient {
  constructor() {
    super('post_sale_cases', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  create(payload = {}) {
    return axios.post(this.url, payload);
  }

  counts() {
    return axios.get(`${this.url}/counts`);
  }

  dashboard(params = {}) {
    return axios.get(`${this.url}/dashboard`, { params });
  }

  agenda(params = {}) {
    return axios.get(`${this.url}/agenda`, { params });
  }

  clients(params = {}) {
    return axios.get(`${this.url}/clients`, { params });
  }

  addresses(params = {}) {
    return axios.get(`${this.url}/addresses`, { params });
  }

  deedAvailability(id, params = {}) {
    return axios.get(`${this.url}/${id}/deed_availability`, { params });
  }

  statusCatalog() {
    return axios.get(`${this.url}/status_catalog`);
  }

  history(id) {
    return axios.get(`${this.url}/${id}/history`);
  }

  registryStatus(id) {
    return axios.get(`${this.url}/${id}/registry_status`);
  }

  view(id) {
    return axios.post(`${this.url}/${id}/view`);
  }

  transition(id, payload = {}) {
    return axios.post(`${this.url}/${id}/transition`, payload);
  }

  complete(id) {
    return axios.post(`${this.url}/${id}/complete`);
  }

  cancel(id, payload = {}) {
    return axios.post(`${this.url}/${id}/cancel`, payload);
  }

  assign(id, payload = {}) {
    return axios.post(`${this.url}/${id}/assign`, payload);
  }

  addNote(id, payload = {}) {
    return axios.post(`${this.url}/${id}/add_note`, payload);
  }

  externalAction(id, payload = {}) {
    return axios.post(`${this.url}/${id}/external_action`, payload);
  }
}

export default new PostSaleCasesAPI();
